<script setup lang="ts">
import { formatYearRange } from "~/utilities/format"
import type { PersonRelation } from "~/types/article"

defineProps({
  note: {
    type: Object as PropType<PersonRelation>,
    required: true,
  },
})
</script>

<template>
  <USidenote :note="note" title-class="text-dark-blue-dark">
    <template #sidenoteType>
      <span>
        | ({{
          formatYearRange(
            note.resource.birthYear,
            note.resource.deceasedYear,
          )
        }})</span
      >
    </template>
    <template #content>
      <div v-html="note.resource.about" />
    </template>
  </USidenote>
</template>
